import { useEffect, useState } from "react";
import { Plus, Trash2, Power } from "lucide-react";
import { toast } from "sonner";
import adminApi, { apiError } from "@/services/adminApi";

const inputCls = "px-3 py-2 bg-zinc-800/80 border border-zinc-700/40 rounded-lg text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-amber-500/50";

export default function DomainsPage() {
  const [domains, setDomains] = useState([]);
  const [newDomain, setNewDomain] = useState("");
  const [role, setRole] = useState("stream");

  const load = () => adminApi.domains().then(({ data }) => setDomains(data.domains)).catch(() => {});
  useEffect(() => { load(); }, []);

  const handleAdd = async () => {
    if (!newDomain.trim()) return;
    try {
      await adminApi.createDomain({ domain: newDomain.trim(), role, order: domains.length });
      setNewDomain("");
      toast.success("Domen əlavə olundu");
      load();
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  const toggleActive = async (d) => {
    const { id, ...rest } = d;
    await adminApi.updateDomain(id, { ...rest, active: !d.active });
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Domen silinsin?")) return;
    await adminApi.deleteDomain(id);
    load();
  };

  const roleLabels = { stream: "Stream", api: "API", archive: "Arxiv" };

  return (
    <div data-testid="admin-domains-page">
      <h1 className="text-2xl font-bold mb-1">DNS Rotator</h1>
      <p className="text-sm text-zinc-500 mb-6">Client-lər aktiv domenləri sıra ilə yoxlayır — bloklanma zamanı avtomatik növbəti domenə keçir. Public API: <code className="text-amber-400">/api/app/domains</code></p>

      <div className="flex flex-col md:flex-row gap-2 mb-6">
        <input
          data-testid="domain-input"
          placeholder="domen.example.az"
          value={newDomain}
          onChange={(e) => setNewDomain(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleAdd()}
          className={`${inputCls} md:w-72`}
        />
        <select value={role} onChange={(e) => setRole(e.target.value)} className={inputCls} data-testid="domain-role-select">
          <option value="stream">Stream</option>
          <option value="api">API</option>
          <option value="archive">Arxiv</option>
        </select>
        <button data-testid="domain-add-btn" onClick={handleAdd} className="flex items-center gap-2 px-4 py-2 bg-amber-500 hover:bg-amber-400 text-black font-semibold rounded-lg text-sm transition-colors">
          <Plus className="w-4 h-4" /> Əlavə et
        </button>
      </div>

      <div className="space-y-2">
        {domains.length === 0 && <p className="text-zinc-500 text-sm">Domen yoxdur.</p>}
        {domains.map((d) => (
          <div key={d.id} data-testid={`domain-row-${d.id}`} className={`flex items-center gap-4 bg-zinc-900/60 border border-zinc-800 rounded-xl px-4 py-3 ${!d.active ? "opacity-50" : ""}`}>
            <span className={`w-2 h-2 rounded-full flex-shrink-0 ${d.active ? "bg-green-500" : "bg-zinc-600"}`} />
            <div className="flex-1 min-w-0">
              <p className="font-mono text-sm truncate">{d.domain}</p>
              <p className="text-[10px] text-zinc-500">{roleLabels[d.role] || d.role} · Sıra: {d.order}</p>
            </div>
            <button onClick={() => toggleActive(d)} className={`p-2 rounded-lg transition-colors ${d.active ? "text-green-400 hover:bg-green-500/10" : "text-zinc-500 hover:bg-white/5"}`} title={d.active ? "Deaktiv et" : "Aktiv et"}>
              <Power className="w-4 h-4" />
            </button>
            <button data-testid={`domain-delete-${d.id}`} onClick={() => handleDelete(d.id)} className="p-2 text-zinc-400 hover:text-red-400 transition-colors">
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
